import { render, staticRenderFns } from "./icon-price-catalog.vue?vue&type=template&id=9d9c75ac"
import script from "./icon-price-catalog.vue?vue&type=script&lang=js"
export * from "./icon-price-catalog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports